import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-relative tw-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-[2px] tw-bg-[#ff7f50]" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { PropType, onMounted, onUpdated, ref } from "vue";
import ButtonShowMore from "./buttonShowMore.vue";
import CustomDropDownItem from "../customDropDownItem.vue";
import { actionClickType, CHECKLISTSTATUS } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellTableAction',
  props: {
  isInternal: { type: Boolean, default: false },
  actions: { type: Array as PropType<string[]>, default: () => [""] },
  classValue: { type: String, default: "" },
  value: { type: Object as PropType<any>, required: true },
  iconClass: { type: String, default: "", required: false },
  inModalEdit: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: "", required: false },
  dataCyId: { type: String, default: "", required: false },
  classButton: { type: String, default: "" },
},
  emits: ["manage-user"],
  setup(__props, { emit }) {

const props = __props;




const valueItem: any = ref(props.value.item);
const isInternal: any = ref(props.isInternal);

onMounted(() => {
  valueItem.value = props.value.item;
  isInternal.value = props.isInternal;
});

onUpdated(() => {
  valueItem.value = props.value.item;
  isInternal.value = props.isInternal;
});

const clickEvent = (action: any = "") => {
  if (isInternal.value)
    emit("manage-user", valueItem.value, action, isInternal.value);
  else emit("manage-user", valueItem.value, action);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ButtonShowMore, {
      disabled: __props.disabled,
      "id-popover": `'popover-btn-show-more-${__props.id}'`,
      "is-from-notification": true,
      "icon-class": __props.iconClass,
      classes: __props.classButton,
      "data-cy-id": __props.dataCyId
    }, {
      default: _withCtx(() => [
        (__props.actions.includes(_unref(actionClickType).actionManageUser))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 0,
              "data-cy": 'manage-user-menu',
              style: 'normal',
              "id-text": 'app-settings-team-members-more-modal-manage-user-1',
              onClick: _cache[0] || (_cache[0] = () => clickEvent(''))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionResetPassword))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 1,
              style: 'normal',
              "id-text": 'app-settings-team-members-more-modal-reset-password-1',
              onClick: _cache[1] || (_cache[1] = () => clickEvent(_unref(actionClickType).actionResetPassword))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionAddMFA))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 2,
              style: 'normal',
              "data-cy": 'manage-user-menu-add-mfa',
              "id-text": 'app-settings-team-members-profile-modal-add-mfa-action-title-1',
              onClick: _cache[2] || (_cache[2] = () => clickEvent(_unref(actionClickType).actionAddMFA))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionAddAnotherMFA))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 3,
              style: 'normal',
              "id-text": 'app-settings-team-members-profile-modal-add-another-mfa-action-title-1',
              onClick: _cache[3] || (_cache[3] = () => clickEvent(_unref(actionClickType).actionAddAnotherMFA))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionResetMFA))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 4,
              style: 'normal',
              "data-cy": 'manage-user-menu-reset-mfa',
              "id-text": 'app-settings-team-members-more-modal-reset-mfa-1',
              onClick: _cache[4] || (_cache[4] = () => clickEvent(_unref(actionClickType).actionResetMFA))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionEnableMFA))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 5,
              style: 'normal',
              "data-cy": 'manage-user-menu-enable-mfa',
              "id-text": 'app-user-profile-actions-enable-mfa-1',
              onClick: _cache[5] || (_cache[5] = () => clickEvent(_unref(actionClickType).actionResetMFA))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionDeactivate) &&
            ((valueItem.value.status === 'active' && isInternal.value) || !isInternal.value)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 6,
              style: 'normal',
              "data-cy": 'manage-user-menu-deactive-user',
              "id-text": 'app-settings-team-members-more-modal-deactivate-user-1',
              onClick: _cache[6] || (_cache[6] = () => clickEvent(_unref(actionClickType).actionDeactivate))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionActive) &&
            ((valueItem.value.status === 'deactivated' && isInternal.value) || !isInternal.value)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 7,
              style: 'normal',
              "data-cy": 'manage-user-menu-active-user',
              "id-text": 'app-settings-team-members-more-modal-activate-user-1',
              onClick: _cache[7] || (_cache[7] = () => clickEvent(_unref(actionClickType).actionActive))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionDownload))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 8,
              style: 'normal',
              "id-text": 'app-common-action-download-title-1',
              onClick: _cache[8] || (_cache[8] = () => clickEvent(_unref(actionClickType).actionDownload))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionUnlockUser) &&
            valueItem.value.isLocked
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 9,
              style: 'normal',
              "id-text": 'app-settings-team-members-more-modal-unlock-user-1',
              onClick: _cache[9] || (_cache[9] = () => clickEvent(_unref(actionClickType).actionUnlockUser))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionResendInvite))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 10,
              style: 'normal',
              "data-cy": "resend-invite-button",
              "id-text": 'app-settings-resend-invite-1',
              onClick: _cache[10] || (_cache[10] = () => clickEvent(_unref(actionClickType).actionResendInvite))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionDeleteUser))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 11,
              style: 'danger',
              "data-cy": 'manage-user-menu-delete-user',
              "id-text": 'app-settings-team-members-more-modal-delete-user-1',
              onClick: _cache[11] || (_cache[11] = () => clickEvent(_unref(actionClickType).actionDeleteUser))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionRemoveAccess))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 12,
              style: 'danger',
              "data-cy": 'manage-user-menu-remove-all-access-user',
              "id-text": 'app-settings-team-members-profile-modal-actions-remove-all-access-1',
              onClick: _cache[12] || (_cache[12] = () => clickEvent(_unref(actionClickType).actionRemoveAccess))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionRemoveOrgAccess))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 13,
              style: 'danger',
              "id-text": 'app-settings-team-members-profile-modal-remove-access-button-1',
              onClick: _cache[13] || (_cache[13] = () => clickEvent(_unref(actionClickType).actionRemoveOrgAccess))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionProcessRequest))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 14,
              style: 'normal',
              "id-text": 'app-settings-organisation-manage-access-bulk-actions-modal-accept-request-1',
              onClick: _cache[14] || (_cache[14] = () => clickEvent(_unref(actionClickType).actionProcessRequest))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionProcessOffer))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 15,
              style: 'normal',
              "id-text": 'app-settings-organisation-manage-access-bulk-actions-modal-accept-offer-1',
              onClick: _cache[15] || (_cache[15] = () => clickEvent(_unref(actionClickType).actionProcessOffer))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionRemoveFile))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 16,
              style: 'danger',
              "id-text": 'app-component-assessments-evidence-modal-file-table-action-delete-1',
              onClick: _cache[16] || (_cache[16] = () => clickEvent(_unref(actionClickType).actionRemoveFile))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionVerifyDomain) &&
            !valueItem.value?.isVerified.isVerifiedDNS
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 17,
              style: 'normal',
              "id-text": 'app-settings-domain-verify-domain-1',
              onClick: _cache[17] || (_cache[17] = () => clickEvent(_unref(actionClickType).actionVerifyDomain))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionManageDomain) &&
            !valueItem.value?.isVerified.isVerifiedDNS
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 18,
              style: 'normal',
              "id-text": 'app-settings-domain-manage-domain-2',
              onClick: _cache[18] || (_cache[18] = () => clickEvent(_unref(actionClickType).actionManageDomain))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionUnVerifyDomain) &&
            valueItem.value?.isVerified.isVerifiedDNS
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 19,
              style: 'normal',
              "data-cy": "un-verify-domain-button",
              "id-text": 'app-settings-domain-un-verify-domain-1',
              onClick: _cache[19] || (_cache[19] = () => clickEvent(_unref(actionClickType).actionUnVerifyDomain))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionUnVerifyEmail))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 20,
              style: 'normal',
              "data-cy": "un-verify-email-button",
              "id-text": 'app-settings-domain-un-verify-email-1',
              onClick: _cache[20] || (_cache[20] = () => clickEvent(_unref(actionClickType).actionUnVerifyEmail))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionSendVerificationEmail) &&
            !valueItem.value?.isVerified.isVerifiedEmail
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 21,
              style: 'normal',
              "id-text": 'app-settings-domain-send-verification-email-1',
              onClick: _cache[21] || (_cache[21] = () => clickEvent(_unref(actionClickType).actionSendVerificationEmail))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionDeleteDomain))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 22,
              style: 'danger',
              "data-cy": "delete-domain-button",
              "id-text": 'app-settings-domain-delete-domain-1',
              onClick: _cache[22] || (_cache[22] = () => clickEvent(_unref(actionClickType).actionDeleteDomain))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionEditActionRecomendation))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 23,
              style: 'normal',
              "id-text": 'app-assess-recommendations-section-action-edit-action-option-1',
              onClick: _cache[23] || (_cache[23] = 
            () => clickEvent(_unref(actionClickType).actionEditActionRecomendation)
          )
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionShowAssessmentsAdvanced))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 24,
              style: 'normal',
              "id-text": 'app-component-assessments-advanced-title-1',
              onClick: _cache[24] || (_cache[24] = 
            () => clickEvent(_unref(actionClickType).actionShowAssessmentsAdvanced)
          )
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionMarkAsComplete) &&
            (valueItem.value.checklistGroupCompletionPcnt === null ||
              valueItem.value.checklistGroupCompletionPcnt !== 1)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 25,
              style: 'normal',
              "id-text": 'app-assess-recommend-action-status-mark-1',
              "custom-text-class": `tw-flex tw-items-center tw-gap-[5px]`,
              "tag-status": _unref(CHECKLISTSTATUS).DONE,
              "tag-status-id": _unref(CHECKLISTSTATUS).DONE,
              onClick: _cache[25] || (_cache[25] = () => clickEvent(_unref(actionClickType).actionMarkAsComplete))
            }, null, 8, ["tag-status", "tag-status-id"]))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionMarkAsInProgress) &&
            (valueItem.value.checklistGroupCompletionPcnt === null ||
              valueItem.value.checklistGroupCompletionPcnt === 0 ||
              valueItem.value.checklistGroupCompletionPcnt === 1)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 26,
              style: 'normal',
              "id-text": 'app-assess-recommend-action-status-mark-1',
              "custom-text-class": `tw-flex tw-items-center tw-gap-[5px]`,
              "tag-status": _unref(CHECKLISTSTATUS).INPROG,
              "tag-status-id": _unref(CHECKLISTSTATUS).INPROG,
              onClick: _cache[26] || (_cache[26] = () => clickEvent(_unref(actionClickType).actionMarkAsInProgress))
            }, null, 8, ["tag-status", "tag-status-id"]))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionMarkAsNotStarted) &&
            (valueItem.value.checklistGroupCompletionPcnt === null ||
              valueItem.value.checklistGroupCompletionPcnt !== 0)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 27,
              style: 'normal',
              "id-text": 'app-assess-recommend-action-status-mark-1',
              "custom-text-class": `tw-flex tw-items-center tw-gap-[5px]`,
              "tag-status": _unref(CHECKLISTSTATUS).NOT_STARTED,
              "tag-status-id": _unref(CHECKLISTSTATUS).NOT_STARTED,
              onClick: _cache[27] || (_cache[27] = () => clickEvent(_unref(actionClickType).actionMarkAsNotStarted))
            }, null, 8, ["tag-status", "tag-status-id"]))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionClearStatus) &&
            valueItem.value.checklistGroupCompletionPcnt !== null
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 28,
              style: 'normal',
              "id-text": 'app-assess-recommend-action-clear-status-1',
              onClick: _cache[28] || (_cache[28] = () => clickEvent(_unref(actionClickType).actionClearStatus))
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(
              _unref(actionClickType).actionMarkAsQuickWinRecomendation,
            ) && valueItem.value.checklistGroupIsQuickWin
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 29,
              "data-cy": 'manage-user-menu-quickwin-recommendation',
              style: 'normal',
              "id-text": 'app-assess-recommend-action-mark-quickwin-1',
              onClick: _cache[29] || (_cache[29] = 
            () => clickEvent(_unref(actionClickType).actionMarkAsQuickWinRecomendation)
          )
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(
              _unref(actionClickType).actionMarkAsQuickWinRecomendation,
            ) && !valueItem.value.checklistGroupIsQuickWin
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 30,
              style: 'normal',
              "data-cy": 'manage-user-menu-not-quickwin-recommendation',
              "id-text": 'app-assess-recommend-action-mark-notquickwin-1',
              onClick: _cache[30] || (_cache[30] = 
            () => clickEvent(_unref(actionClickType).actionMarkAsQuickWinRecomendation)
          )
            }))
          : _createCommentVNode("", true),
        (
            __props.actions.includes(_unref(actionClickType).actionDeleteActionRecomendation)
          )
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 31,
              style: 'danger',
              "id-text": 'app-assess-recommend-action-delete-action-1',
              onClick: _cache[31] || (_cache[31] = 
            () => clickEvent(_unref(actionClickType).actionDeleteActionRecomendation)
          )
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionAddActionQuestion))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 32,
              style: 'normal',
              "id-text": 'app-assess-recommendations-action-table-bulk-actions-modal-add-action-1',
              onClick: _cache[32] || (_cache[32] = () => clickEvent(_unref(actionClickType).actionAddActionQuestion))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionRemoveFormAction))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 33,
              style: 'danger',
              "id-text": 'app-assess-recommendations-action-table-bulk-actions-modal-remove-from-action-1',
              onClick: _cache[33] || (_cache[33] = () => clickEvent(_unref(actionClickType).actionRemoveFormAction))
            }))
          : _createCommentVNode("", true),
        (__props.actions.includes(_unref(actionClickType).actionRestoreUser))
          ? (_openBlock(), _createBlock(CustomDropDownItem, {
              key: 34,
              style: 'normal',
              "id-text": 'app-assess-recommendations-action-table-bulk-actions-restore-user-1',
              onClick: _cache[34] || (_cache[34] = () => clickEvent(_unref(actionClickType).actionRestoreUser))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["disabled", "id-popover", "icon-class", "classes", "data-cy-id"]),
    (__props.inModalEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"position":"relative","z-index":"0"},
          class: "tw-flex tw-items-center tw-justify-center tw-absolute tw-right-0 tw-w-7 tw-h-7 tw-rounded-full tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#fff] tw-cursor-pointer",
          onClick: _cache[35] || (_cache[35] = () => clickEvent(_unref(actionClickType).actionDeleteActionQuestion))
        }, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})